import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import Loader from "components/Atoms/SharedComponents/Loader/Loader";
import ProductDetails from "components/Organisms/products/details";
import CustomersReviews from "pages/products/customerReviews";
import ProductVariants from "pages/products/productVariants";
import { useSelector } from "react-redux";
import ProductDetailsTemplate from "templates/products/productsListing/productDetails";
import { handleTabChange } from "services/modules/utils/Helper";
import ProductRecommendations from "components/Organisms/products/recommendations";

export default function ProductsDetailsPage({ details, setOpenDeleteModal }) {
  const { t } = useTranslation();
  const currentUser = useSelector(
    (state) => state.authenticate.currentUserProfile,
  );
  const variantPermissions = useSelector(
    (state) => state.authenticate.currentUserProfile.permissions.variants,
  );
  const reviewPermissions = useSelector(
    (state) => state.authenticate.currentUserProfile.permissions.reviews,
  );
  const isSuperAdmin = currentUser?.privilege == "super_admin";
  const status = details?.approval_status;
  const load = useSelector((state) => state.products.load);
  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(window.location.search),
  );

  const selectedTab = searchParams.get("tab");
  const [value, setValue] = useState(+selectedTab || 0);

  const tabs = [
    {
      title: t("products.label_details"),
      children: <ProductDetails details={details} />,
    },
    status == "available" &&
      (isSuperAdmin || variantPermissions?.can_read) && {
        title: t("products.label_variants"),
        children: (
          <ProductVariants
            list={details?.variants}
            optionTypes={details?.option_types}
            storeId={details?.store?.id}
            variantPermissions={variantPermissions}
            isSuperAdmin={isSuperAdmin}
          />
        ),
      },
    (isSuperAdmin || reviewPermissions?.can_read) && {
      title: t("products.label_reviews"),
      children: <CustomersReviews details={details} />,
    },
    {
      title: t("products.label_recommendations"),
      children: <ProductRecommendations id={details?.id} />,
    },
  ];

  return (
    <>
      <Loader open={load?.loading && load?.type == "details"} />
      <ProductDetailsTemplate
        details={details}
        setOpenDeleteModal={setOpenDeleteModal}
        selectedTab={value}
        tabs={tabs?.filter((tab) => tab)} // as there is a condition inside the above tabs, that might return false
        handleTabChange={(event, newValue) =>
          handleTabChange({
            event,
            newValue,
            setValue,
            searchParams,
            setSearchParams,
          })
        }
      />
      {/* {memoizedDetailsTab} */}
    </>
  );
}
